<div class="modal-header">
  <h5 class="modal-title">Create Observation for {{targetUserName}}</h5>
  <button type="button" class="btn btn-info cancel" (click)="activeModal.dismiss('cancel')"><i
      class="fas fa-times"></i></button>
</div>

<div class="modal-body">
  <form [formGroup]="observationForm" (ngSubmit)="onSubmit(observationForm)">
    <div class="p-1">
      <div class="text-danger"
        *ngIf="!observationForm.controls['ObservationType'].valid && observationForm.controls['ObservationType'].touched">
        You must enter a valid observation type.</div>
      <label for="observationType">Observation Type <span class="required">*</span></label>
      <select #observationType class="form-control form-control-sm" id="ObservationType" name="ObservationType"
        formControlName="ObservationType" (change)="onObservationTypeChange(observationType.value)">
        <option [defaultSelected]=true value=0 disabled>Select One</option>
        <option *ngFor="let opt of filteredOptions" [value]="opt.value">{{opt.label}}</option>
      </select>
    </div>

    <div *ngIf="shouldShowRubricTypePicker()" class="p-1">
      <label for="RubricDirectionType">Rubric Type<span class="required">*</span></label>
      <select class="form-control form-control-sm" formControlName="RubricDirectionType">
        <option [defaultSelected]=true [ngValue]="null" disabled>Select One</option>
        <option *ngFor="let rubricDirectionType of rubricDirectionTypes" [ngValue]="rubricDirectionType.value">
          {{rubricDirectionType.label}}
        </option>
      </select>
    </div>

    <div *ngIf="shouldShowRolePicker()" class="p-1">
      <label for="UserRole">User Role <span class="required">*</span></label>
      <select class="form-control form-control-sm" formControlName="UserRole">
        <option [defaultSelected]=true [ngValue]="null" disabled>Select One</option>
        <option *ngFor="let userRole of filteredTargetUserRoles" [ngValue]="userRole.ntpeLookupID ?? DEFAULT_USER_ROLE_ID">
          {{userRole.displayName}}
        </option>
      </select>
    </div>

    <div class="p-1">
      <div class="text-danger"
        *ngIf="!observationForm.controls['SchoolYear'].valid && observationForm.controls['SchoolYear'].touched">
        You must enter a valid school year.</div>
      <label for="schoolYear">School Year <span class="required">*</span></label>
      <select class="form-control form-control-sm" formControlName="SchoolYear">
        <option [defaultSelected]=true value="" disabled>Select One</option>
        <option *ngFor="let opt of filteredSchoolYears" [value]="opt">{{opt}}</option>
      </select>
    </div>


    <div *ngIf="showRatingFormOptions()" class="p-1">
      <label for="SubType">Select Rating Type <span class="required">*</span></label>
      <select class="form-control form-control-sm" formControlName="SubType">
        <option [defaultSelected]=true [ngValue]="null" disabled>Select One</option>
        <option *ngFor="let formOpt of ratingFormOptions" [ngValue]="formOpt.value">{{formOpt.label}}</option>
      </select>
    </div>


    <div *ngIf="showAdditionalText()" class="p-1">
      <label for="schoolYear">Message for Employee</label>
      <textarea formControlName="AdditionalText" rows="2" class="form-control"></textarea>
    </div>

    <div *ngIf="showAdditionalOptionsSPM()" class="p-1">
      <div class="text-danger"
        *ngIf="!observationForm.controls['PerformanceMeasureType'].valid && observationForm.controls['PerformanceMeasureType'].touched">
        You must enter a valid performance measure type.</div>
      <label for="performanceMeasureType">Performance Measure Type <span class="required">*</span></label>
      <select class="form-control form-control-sm" formControlName="PerformanceMeasureType" (change)="onObservationTypeChange(observationType.value)">
        <option *ngFor="let opt of filteredPerformanceMeasureTypes" [value]="opt.value">{{opt.label}}</option>
      </select>
    </div>

    <div *ngIf="showPresetOptions()" class="p-1">
        <div class="p-1">
            <label for="preset">Select Preset</label>
            <select class="form-control form-control-sm" formControlName="Preset">
                <option [defaultSelected]=true [ngValue]="null">No Preset</option>
                <option *ngFor="let opt of filteredPresets" [value]="opt.presetID">{{opt.name}}</option>
            </select>
        </div>
    </div>


    <div *ngIf="showEvaluatorOptions()" class="p-1">
      <div class="text-danger"
        *ngIf="!observationForm.controls['Evaluator'].valid && observationForm.controls['Evaluator'].touched">
        You must enter a valid Evaluator.</div>
      <label for="evaluator">Select Evaluator <span class="required">*</span></label>
      <select class="form-control form-control-sm" formControlName="Evaluator">
        <option [defaultSelected]=true [ngValue]="null" disabled>Select One</option>
        <option *ngFor="let opt of evaluators" [value]="opt.value">{{opt.label}}</option>
      </select>
    </div>

    <div *ngIf="currentObservationType == '9'" class="custom-form-selector-container" class="p-1 mt-2" formGroupName="CustomFormSelector">
      <label for="evaluator">Select Custom Form <span class="required">*</span></label>
      <paetep-custom-form-selector-paging [targetUserId]="targetUserId">
      </paetep-custom-form-selector-paging>
    </div>

    <div class="text-right p-1">
      <button type="button" class="btn btn-primary mr-2" [disabled]="observationForm.invalid"
        (click)="onSubmit(observationForm)"><i class="far fa-plus"></i> Create Observation</button>
      <button type="button" class="btn btn-info m-2" (click)="activeModal.close()">Cancel</button>
    </div>

  </form>
</div>
